import { FC } from 'react';

import { Study } from '@/shared/api/protocol-ts/model/dto_study_pb';
import { Timeline } from '@/shared/ui';

import { useRawMeshViewerTimelineItem } from '../../hooks';
import { RawMeshViewerActionsPopover } from '../RawMeshViewerActionsPopover/RawMeshViewerActionsPopover';

type RawMeshViewerTimelineCardProps = {
  study: Study;
  className?: string;
  testID?: string;
};

export const RawMeshViewerTimelineCard: FC<RawMeshViewerTimelineCardProps> = (
  props,
) => {
  const { study, className, testID } = props;

  const item = useRawMeshViewerTimelineItem(study);

  return (
    <Timeline.Card
      className={className}
      dataComponent="raw-mesh-viewer-timeline-card"
      time={item.time}
      title={item.title}
      meta={item.meta}
      preview={item.preview}
      isRemoving={item.isRemoving}
      testID={testID}
      actions={<RawMeshViewerActionsPopover {...item.actionsProps} />}
      onClick={item.handleClick}
    />
  );
};
